(function(){
  function run(){
    var body=document.querySelector('.article__body'); if(!body) return;
    // 1. reading time under H1
    var h1=document.querySelector('.section-header__title');
    if(h1 && !document.querySelector('.article__readtime')){
      var txt=(body.innerText||'').trim();
      var w=txt?txt.split(/\s+/).length:0;
      var rt=Math.max(1,Math.round(w/220));
      var el=document.createElement('div');
      el.className='article__readtime';
      el.textContent=rt+' min read';
      h1.insertAdjacentElement('afterend', el);
    }
    // 2. find the TOC: (a) .table-of-contents, (b) a "Table of Contents" heading + its ul, (c) the first ul of in-page anchors
    var toc=body.querySelector('.table-of-contents');
    if(!toc){
      var cand=body.querySelectorAll('h2,h3,p');
      for(var i=0;i<cand.length;i++){
        if(/^table of contents/i.test((cand[i].textContent||'').trim())){
          var head=cand[i], ul=head.nextElementSibling;
          while(ul && ul.tagName!=='UL'){ ul=ul.nextElementSibling; }
          if(ul){ var wrap=document.createElement('div'); wrap.className='table-of-contents'; head.parentNode.insertBefore(wrap,head); wrap.appendChild(head); wrap.appendChild(ul); toc=wrap; }
          break;
        }
      }
    }
    if(!toc){
      var uls=body.querySelectorAll('ul');
      for(var u=0;u<uls.length;u++){
        if(uls[u].querySelectorAll('a[href^="#"]').length>=3){
          var w2=document.createElement('div'); w2.className='table-of-contents';
          uls[u].parentNode.insertBefore(w2, uls[u]);
          var pv=w2.previousElementSibling;
          if(pv && /contents/i.test((pv.textContent||'').trim()) && (pv.textContent||'').trim().length<40){ w2.appendChild(pv); }
          else { var hh=document.createElement('h2'); hh.textContent='Table of Contents'; w2.appendChild(hh); }
          w2.appendChild(uls[u]);
          toc=w2; break;
        }
      }
    }
    // 3. hide duplicate TOCs
    var all=body.querySelectorAll('.table-of-contents');
    for(var j=1;j<all.length;j++){ all[j].style.display='none'; }
    // 4. smooth-scroll (header offset) + text-match fallback for id mismatches
    if(toc){
      var links=toc.querySelectorAll('a[href^="#"]');
      links.forEach(function(a){
        a.addEventListener('click', function(e){
          var id=decodeURIComponent(a.getAttribute('href').slice(1));
          var tg=document.getElementById(id);
          if(!tg){
            var lt=(a.textContent||'').trim().toLowerCase().replace(/\s+/g,' ');
            var hs=body.querySelectorAll('h2,h3');
            for(var k=0;k<hs.length;k++){ if((hs[k].textContent||'').trim().toLowerCase().replace(/\s+/g,' ')===lt){ tg=hs[k]; break; } }
          }
          if(tg){ e.preventDefault(); var y=tg.getBoundingClientRect().top+window.pageYOffset-110; window.scrollTo({top:y, behavior:'smooth'}); }
        });
      });
    }
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
